import * as React from 'react';
import { CssBaseline, Grid, Paper, useTheme } from '@mui/material';
import { environment } from '../../environment';

const env = environment();

interface ILayoutSigninProps {
    children: React.ReactNode;
}

export const LayoutSignin: React.FC<ILayoutSigninProps> = ({ children }) => {
    const theme = useTheme();

    return (
        <React.Fragment>
            <Grid container component="main" sx={{ height: '100vh' }}>
                <CssBaseline />
                <Grid item xs={false} sm={4} md={9}
                    sx={{
                        backgroundImage: `url(${theme.palette.mode === 'dark' ? env.signinImageLight : env.signinImage})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: env.backgroundSize,
                        backgroundPosition: 'center',
                        opacity: env.opacity,
                        backgroundColor: theme.palette.background.default
                    }}
                />
                <Grid item xs={12} sm={8} md={3} component={Paper} elevation={6} square>
                    {children}
                </Grid>
            </Grid>
        </React.Fragment >
    );
};
